export const debuffEffects = {
  damageReceiptPlus: {
    primitives: ['scaleDamageIntakeAll'],
    resources: {}
  },
  roleSkillDmgReceiptPlus: {
    primitives: ['scaleDamageIntakeRole'],
    resources: {}
  },
  breakArmourMech: {
    primitives: ['scaleArmourMech'],
    resources: {}
  },
  breakArmourElec: {
    primitives: ['scaleArmourElec'],
    resources: {}
  }
} as const;
